<template>
    <div>

        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="ICCID：">
                <el-input  v-model.trim="searchForm.iccid" @keyup.enter.native="getStopRecordListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="停机状态："> 
                <el-select v-model="searchForm.stateName" clearable>
                    <el-option label="停机成功" value="成功"></el-option> 
                    <el-option label="停机失败" value="失败"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getStopRecordListHandler">搜索查询</el-button>
                <el-button type="success" plain @click="getStopRecordListHandler">刷新</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" plain @click="confirmExportDialogVisible = true">导出</el-button>
                   <el-button type="primary" @click="whiteClicks">提前停机白名单</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column label="ICCID号" width="180px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" align="center"></el-table-column>
            <!-- <el-table-column prop="supplierName" label="供应商"></el-table-column>
            <el-table-column label="总流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalRateFlow) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalUsedFlow) }}
                </template>
            </el-table-column> -->
            <el-table-column prop="createTime" label="停机时间" align="center"></el-table-column>
            <el-table-column prop="failReason" label="操作结果" align="center"></el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportStopRecordListHandler">确 定</el-button>
            </span>
        </el-dialog>




          <!--白名单弹窗-->
        <el-dialog :append-to-body="true" title="白名单" :visible.sync="whiteShows" width="600px" :close-on-click-modal="false">
            <el-input v-model="querd.iccid" placeholder="请输入iccid" clearable style="width:200px;margin-right:10px;"></el-input>
            <el-button type="default" @click="searcts">查询</el-button>
            <el-button type="primary" @click="addCards">添加卡号</el-button>
            <el-button type="danger" @click="delCards">删除卡号</el-button>
            <el-table :data="dialog.tableData"
                border
                fit
                highlight-current-row
                style="width: 100%;margin:10px 0;"
                :header-cell-style="{background:'#f5f5f5'}"
                height="400"
                >
                    <el-table-column prop="id" label="id" align="center"></el-table-column>
                    <el-table-column prop="iccid" label="显示卡号" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="delDialogDatas(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="dialog.currentPage1"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="dialog.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dialog.total">
                </el-pagination>
        </el-dialog>
        <!---新增白名单-->
        <el-dialog :append-to-body="true" :title="title1" :visible.sync="addWhiteShows" width="600px" :close-on-click-modal="false">
            <el-input v-model="iccidStrs" placeholder="请输入请输入1个或多个卡号,多个请用逗号、空格、或者换行分隔" :rows="10" type="textarea" clearable style="margin-right:10px;" />
            <div style="margin-top:10px">
                <el-button type="default" @click="addSumbits" v-if="title1==='新增白名单'">确定添加</el-button>
                <el-button type="default" @click="addDeletes" v-if="title1==='删除白名单'">确定删除</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {getStopRecordList,exportPollingStopInfo} from '@/api/csm.js'
import {supplierListPage,supplierListAdd ,supplierListUpdate,supplierListDelete,supplierOutPage,supplierOutBatch,supplierOutDelete,supplierOutDelete1,
    supplierOutPages,supplierOutBatchs,supplierOutDeletes,supplierOutDelete1s} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                stateName:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
             dialog:{
                    tableData: [],
                    currentPage: 1,
                    pageSize: 15,
                    total: 0
            },
             title:'',
                title1:'',
                programmeDialog:false,
                whiteShow:false,
                whiteShows:false,
                querd:{
                    iccid:''
                },
                iccidStrs:'',
                addWhiteShow:false,
                addWhiteShows:false,
            confirmExportDialogVisible:false//导出确认框
        }
    },
    methods: {
        searcts(){
                this.getDialogDatas()
            },
             getDialogDatas($event){
                common.resetCurrentPage(this, $event, 'dialog');
                var data = common.getRequestParams(this, 'dialog',this.querd);
                supplierOutPages(data).then(res => {
                    common.listCallback(this, res, 'dialog');
                })
            },
              handleSizeChange1(val){
                this.dialog.pageSize = val;
                this.getDialogData();
            },

            handleCurrentChange1(val){
                this.dialog.currentPage = val;
                this.getDialogData();
            },
          //白名单
            whiteClicks(){
                this.whiteShows=true
                this.getDialogDatas()
            },
             addCards(){
                this.iccidStrs = ''
                this.title1="新增白名单"
                this.addWhiteShows = true
            },
            delCards(){
                this.iccidStrs = ''
                this.title1="删除白名单"
                this.addWhiteShows = true
            },
               //批量新增
            addSumbits(){
                this.$confirm("确定要新增数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutBatchs({iccidStrs:this.iccidStrs}).then(res=>{
                        if(res.data.code == 200){
                            this.addWhiteShows = false
                            this.getDialogDatas()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //批量删除
            addDeletes(){
                this.$confirm("确定要删除数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutDeletes({iccidStrs:this.iccidStrs}).then(res=>{
                        if(res.data.code == 200){
                            this.addWhiteShows = false
                            this.getDialogDatas()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //单个删除
            delDialogDatas(data){
                this.$confirm("确定要删除该数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    supplierOutDelete1s({id:data.id}).then(res=>{
                        if(res.data.code == 200){
                            this.$message.success('操作成功');
                            this.getDialogDatas()
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },


          goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getStopRecordListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getStopRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getStopRecordListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getStopRecordListHandler();
        },
        exportStopRecordListHandler(){
            let _that = this;

            exportPollingStopInfo(_that.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));         
        }    
    },
    created(){
        this.getStopRecordListHandler();
    }
}
</script>